export default function FormErrorMessage({ formErrors, inputName }) {
  /**
   * formErrors = es el objeto donde se almacenan los mensajes de errores
   * inputName = es nombre del input y ademas el atributo dentro de formErrors que contiene el mensaje
   */
  if (formErrors[inputName]) {
    return <small className="p-error block">{formErrors[inputName]}</small>;
  }
}
